import React, { useEffect } from "react";
import Header from "../../../components/header";
import CustomButton from "../../../components/ui/button";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import BackdropLoader from "./backdrop";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import RedeemIcon from "@mui/icons-material/Redeem";
import { withStyles } from "@mui/styles";
import {
  Box,
  Dialog,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import {
  BUTTON_PROCEED,
  BUTTON_DOWNLOAD,
  BUTTON_SHARE,
  PRODUCT_NAME_SAVINGS,
  SLUG_DOWNLOAD,
  SLUG_SHARE,
  SLUG_TAB_TERM,
  SLUG_TAB_SAVINGS,
  SLUG_TROP_PRODUCT,
} from "../../../constants";
import { mapping } from "../../../defaultValues/product";
import { extractPolicyTermFromMapper } from "../../../helpers/product";
import { useStyles } from "../indexFormStyles";

const ProductReview = ({
  classes: {
    containerButton,
    contentScroller,
    cardContainer,
    formGroup,
    labelText,
  },
  form,
  handleBack,
  handleClose,
  handleProceed,
  handleDownload,
  handleShare,
  isFormSubmitted,
  maxADBSumAssured,
  modal,
  selectedProduct,
  quotation,
}) => {
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      fullScreen={true}
      fullWidth={true}
      onClose={handleClose}
      open={modal.review}
      maxWidth={"lg"}
    >
      <Header onClick={() => {}} title={""} isBackButtonVisible={false} />
      <DialogTitle id="simple-dialog-title">
        <Box display="flex" justifyContent="center">
          <SectionTitle
            backButton={true}
            onClickHandler={handleBack}
            title={"Benefit Illustration"}
          />
        </Box>
      </DialogTitle>

      <Box>
        <Box
          m={1}
          pt={0}
          pb={0}
          sx={{ height: window.screen.height < 740 ? "410px" : "486px" }}
          className={contentScroller}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems="center"
            m={2}
            mt={0}
          >
            <Typography variant="subtitle2">{form.productName}</Typography>
          </Box>

          <Box className={formGroup} pb={0}>
            <Stack direction="row" gap={0.5}>
              <CurrencyRupeeIcon fontSize="medium" />
              <FieldLabel label={"What do you pay?"} variant="subtitle2" />
            </Stack>
          </Box>

          <Box
            mb={2}
            flexDirection={"column"}
            className={cardContainer}
            m={0.5}
          >
            <Box className={formGroup} pb={0}>
              <Stack direction="row" gap={0.5}>
                <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                <Typography
                  variant={"caption"}
                  className={labelText}
                  mb={1}
                  fontWeight={450}
                >
                  Pay{" "}
                  <b>
                    {" "}
                    {Number(quotation.premiumIncludingGst).toLocaleString(
                      "en-IN",
                      {
                        maximumFractionDigits: 0,
                        style: "currency",
                        currency: "INR",
                      }
                    )}
                  </b>{" "}
                  {form.paymentFrequency.toLowerCase()} for next{" "}
                  <b>{form.ppt} years</b>
                </Typography>
              </Stack>
            </Box>
          </Box>

          <Box className={formGroup} pb={0} mt={2}>
            <Stack direction="row" gap={1}>
              <RedeemIcon fontSize="medium" />
              <FieldLabel label={"What do you get?"} variant="subtitle2" />
            </Stack>
          </Box>

          <Box flexDirection={"column"} className={cardContainer} m={0.5}>
            {form?.type === SLUG_TAB_SAVINGS && (
              <Box className={formGroup} pb={0}>
                <Stack direction="row" gap={1}>
                  <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                  <Typography
                    variant={"caption"}
                    className={labelText}
                    mb={1}
                    fontWeight={450}
                  >
                    Guaranteed Return of{" "}
                    <b>
                      {" "}
                      {Number(
                        quotation.premiumExcludingGst * 10 +
                          quotation.premiumExcludingGst * 0.01
                      ).toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                        style: "currency",
                        currency: "INR",
                      })}
                    </b>
                  </Typography>
                </Stack>
              </Box>
            )}

            {form?.type === SLUG_TAB_SAVINGS && (
              <Box className={formGroup} pb={0}>
                <Stack direction="row" gap={1}>
                  <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                  <Typography
                    variant={"caption"}
                    className={labelText}
                    mb={1}
                    fontWeight={450}
                  >
                    Assured Death Benefit of{" "}
                    <b>
                      {" "}
                      {Number(quotation.dealthSumAssured).toLocaleString(
                        "en-IN",
                        {
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency: "INR",
                        }
                      )}
                    </b>
                  </Typography>
                </Stack>
              </Box>
            )}

            {form?.type === SLUG_TAB_TERM && (
              <>
                <Box className={formGroup} pb={0}>
                  <Stack direction="row" gap={1}>
                    <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                    <Typography
                      variant={"caption"}
                      className={labelText}
                      mb={1}
                      fontWeight={450}
                    >
                      Your family will receive{" "}
                      <b>
                        {Number(quotation.dealthSumAssured).toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                            style: "currency",
                            currency: "INR",
                          }
                        )}
                      </b>{" "}
                      <br />
                      as life cover upon untimely death
                    </Typography>
                  </Stack>
                </Box>

                {form.productSlug === SLUG_TROP_PRODUCT && (
                  <Box className={formGroup} pb={0}>
                    <Stack direction="row" gap={1}>
                      <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                      <Typography
                        variant={"caption"}
                        className={labelText}
                        mb={1}
                        fontWeight={450}
                      >
                        Return of Premium on Maturity{" "}
                        <b>
                          {" "}
                          {Number(quotation.maturitySumAssured).toLocaleString(
                            "en-IN",
                            {
                              maximumFractionDigits: 0,
                              style: "currency",
                              currency: "INR",
                            }
                          )}
                        </b>
                      </Typography>
                    </Stack>
                  </Box>
                )}
              </>
            )}

            {selectedProduct?.productConfig?.riders?.map(
              (rider) =>
                form?.type === SLUG_TAB_TERM &&
                form.riders[rider.slug] && (
                  <Box className={formGroup} pb={0}>
                    <Stack direction="row" gap={1}>
                      <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                      <Typography
                        variant={"caption"}
                        className={labelText}
                        mb={1}
                        fontWeight={450}
                      >
                        Additional life cover of{" "}
                        <b>
                          {Number(
                            form?.corpus >= maxADBSumAssured
                              ? maxADBSumAssured
                              : form?.corpus
                          ).toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                            style: "currency",
                            currency: "INR",
                          })}
                        </b>{" "}
                        upon death due to accident under{" "}
                        <b>{rider.name} Benefit</b> Rider
                      </Typography>
                    </Stack>
                  </Box>
                )
            )}

            {form?.type === SLUG_TAB_SAVINGS && (
              <>
                <Box className={formGroup} pb={0}>
                  <Stack direction="row" gap={1}>
                    <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                    <Typography
                      variant={"caption"}
                      className={labelText}
                      mb={1}
                      fontWeight={450}
                    >
                      In case of early death, future premiums are{" "}
                      <b>waived off</b>
                    </Typography>
                  </Stack>
                </Box>

                <Box className={formGroup} pb={0}>
                  <Stack direction="row" gap={1}>
                    <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                    <Typography
                      variant={"caption"}
                      className={labelText}
                      mb={1}
                      fontWeight={450}
                    >
                      Earn returns upto
                      <b>
                        {" "}
                        {Number(
                          quotation.maturityTerminalBonus1
                        ).toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency: "INR",
                        })}
                      </b>
                      {quotation.asterisk ? "* " : ""}
                    </Typography>
                  </Stack>
                </Box>

                {selectedProduct && (
                  <Box className={formGroup} pb={0}>
                    <Stack direction="row" gap={1}>
                      <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" />
                      <Typography
                        variant={"caption"}
                        className={labelText}
                        mb={1}
                        fontWeight={450}
                      >
                        We will cover you for the next{" "}
                        <b>
                          {extractPolicyTermFromMapper(selectedProduct, form)}{" "}
                          years
                        </b>
                      </Typography>
                    </Stack>
                  </Box>
                )}
              </>
            )}
          </Box>

          {quotation.asterisk && (
            <Box textAlign={"left"} m={1}>
              <Typography
                variant="caption"
                className={labelText}
                fontWeight={450}
                color="gray"
              >
                <small>* Calculated at the rate of 8% per year</small>
              </Typography>
            </Box>
          )}
        </Box>

        <Box className={containerButton}>
          <Box layout="column">
            <Grid container spacing={1} mb={1}>
              <Grid item xs={6}>
                <CustomButton
                  size="large"
                  variant="contained"
                  color="secondary"
                  icon={true}
                  slug={SLUG_DOWNLOAD}
                  title={BUTTON_DOWNLOAD}
                  type="click"
                  clickHandler={handleDownload}
                  disabled={isFormSubmitted}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomButton
                  size="large"
                  variant="contained"
                  color="secondary"
                  icon={true}
                  slug={SLUG_SHARE}
                  title={BUTTON_SHARE}
                  type="click"
                  clickHandler={handleShare}
                  disabled={isFormSubmitted}
                />
              </Grid>
            </Grid>

            <CustomButton
              size="large"
              color="primary"
              title={BUTTON_PROCEED}
              type="click"
              clickHandler={handleProceed}
              disabled={isFormSubmitted}
            />
          </Box>
        </Box>
      </Box>
      <BackdropLoader backdrop={isFormSubmitted} />
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(ProductReview);
